import Http from "../../services/HTTP";
const GET_LAB_ORDERS = "GET_ORDERS";
const SET_LAB_ACTIVE_TILE = "SET_LAB_ACTIVE_TILE";
const GET_PHARMACY_ORDERS = "GET_PHARMACY_ORDERS";
const SET_PHARMACY_ACTIVE_TILE = "SET_PHARMACY_ACTIVE_TILE";
const READY_PHARMACY_ORDER = "READY_PHARMACY_ORDER";

// Lab and Home Care vendor actions
function laboratoryOrdersWaiting() {
  return {
    type: GET_LAB_ORDERS,
    lab_orders_waiting: true,
    lab_orders_response: {},
    lab_orders_error: {},
  };
}

function laboratoryOrdersSuccess(response) {
  return {
    type: GET_LAB_ORDERS,
    lab_orders_waiting: false,
    lab_orders_response: response,
    lab_orders_error: {},
  };
}

function laboratoryOrdersError(error) {
  return {
    type: GET_LAB_ORDERS,
    lab_orders_waiting: false,
    lab_orders_response: {},
    lab_orders_error: error,
  };
}

function setLabActiveTile(tile) {
  return {
    type: SET_LAB_ACTIVE_TILE,
    lab_active_tile: tile,
  };
}

function getLaboratoryOrders() {
  return (dispatch) => {
    dispatch(laboratoryOrdersWaiting());
    const get = Http.GET("lab-test/v1/orders", {});
    get
      .then((response) => {
        if (response !== undefined) dispatch(laboratoryOrdersSuccess(response));
      })
      .catch((error) => {
        dispatch(laboratoryOrdersError(error));
      });
  };
}

// pharmacy vendor actions

function pharmacyOrdersWaiting() {
  return {
    type: GET_PHARMACY_ORDERS,
    pharmacy_orders_waiting: true,
    pharmacy_orders_response: {},
    pharmacy_orders_error: {},
  };
}

function pharmacyOrdersSuccess(response) {
  return {
    type: GET_PHARMACY_ORDERS,
    pharmacy_orders_waiting: false,
    pharmacy_orders_response: response,
    pharmacy_orders_error: {},
  };
}

function pharmacyOrdersError(error) {
  return {
    type: GET_PHARMACY_ORDERS,
    pharmacy_orders_waiting: false,
    pharmacy_orders_response: {},
    pharmacy_orders_error: error,
  };
}

function setPharmacyActiveTile(tile) {
  return {
    type: SET_PHARMACY_ACTIVE_TILE,
    pharmacy_active_tile: tile,
  };
}

function getPharmacyOrders(skipWaiting = false) {
  return (dispatch) => {
    if (!skipWaiting) {
      dispatch(pharmacyOrdersWaiting());
    }
    const get = Http.GET("pharmacy/v2/orders", {});
    get
      .then((response) => {
        if (response !== undefined) dispatch(pharmacyOrdersSuccess(response));
      })
      .catch((error) => {
        dispatch(pharmacyOrdersError(error));
      })
      .finally(() => {
        if (window.location.pathname === "/panel/dashboard") {
          setTimeout(() => {
            dispatch(getPharmacyOrders(true));
          }, 60000);
        }
      });
  };
}

// Pharmacy ready order
function readyPharmacyOrderWaiting() {
  return {
    type: READY_PHARMACY_ORDER,
    ready_pharmacy_order_waiting: true,
    ready_pharmacy_order_response: {},
    ready_pharmacy_order_error: {},
  };
}

function readyPharmacyOrderSuccess(response) {
  return {
    type: READY_PHARMACY_ORDER,
    ready_pharmacy_order_waiting: false,
    ready_pharmacy_order_response: response,
    ready_pharmacy_order_error: {},
  };
}
function readyPharmacyOrderEmpty() {
  return {
    type: READY_PHARMACY_ORDER,
    ready_pharmacy_order_waiting: false,
    ready_pharmacy_order_response: {},
    ready_pharmacy_order_error: {},
  };
}

function readyPharmacyOrderError(error) {
  return {
    type: READY_PHARMACY_ORDER,
    ready_pharmacy_order_waiting: false,
    ready_pharmacy_order_response: {},
    ready_pharmacy_order_error: error,
  };
}

function readyPharmacyOrder(id, data) {
  return (dispatch) => {
    dispatch(readyPharmacyOrderWaiting());
    const get = Http.POST("pharmacy/v1/orders/ready/" + id, data);
    get
      .then((response) => {
        if (response !== undefined)
          dispatch(readyPharmacyOrderSuccess(response));
      })
      .catch((error) => {
        dispatch(readyPharmacyOrderError(error));
      });
  };
}

export {
  GET_LAB_ORDERS,
  getLaboratoryOrders,
  SET_LAB_ACTIVE_TILE,
  setLabActiveTile,
  GET_PHARMACY_ORDERS,
  getPharmacyOrders,
  SET_PHARMACY_ACTIVE_TILE,
  setPharmacyActiveTile,
  READY_PHARMACY_ORDER,
  readyPharmacyOrder,
  readyPharmacyOrderEmpty,
};
